import React from "react";
import { motion } from "framer-motion";
import { RevealLineInView } from "./RevealLine";
import { handleInstall } from "@/lib/install";

export default function ClosingCTA() {
  return (
    <section
      data-testid="closing-cta"
      className="relative px-6 md:px-10 py-20 md:py-32 border-t border-ink-10 overflow-hidden"
    >
      <div className="flex flex-col items-center text-center">
        <div className="w-full">
          <h2 className="font-serif text-center text-[13vw] md:text-[10.2vw] lg:text-[9vw] leading-[0.92] tracking-[-0.02em]">
            <div>
              <RevealLineInView>Give your AI a</RevealLineInView>
            </div>
            <div>
              <RevealLineInView delay={0.1}>
                place to <span className="italic text-[hsl(38_92%_55%)]">work.</span>
              </RevealLineInView>
            </div>
          </h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.4 }}
          className="mt-10 flex w-full max-w-[440px] flex-col gap-3"
        >
          <a
            href="#top"
            onClick={handleInstall}
            data-testid="closing-install-cta"
            className="relative inline-flex items-center justify-center gap-3 px-6 py-4 bg-ink text-[color:var(--w-bg)] font-mono text-[11px] uppercase tracking-[0.18em] hover:bg-cobalt transition-[background-color] duration-200"
          >
            <span>Install Windie</span>
          </a>
          <a
            href="https://github.com/buiilding/Windie-Sandbox"
            target="_blank"
            rel="noreferrer"
            data-testid="closing-project-cta"
            className="relative inline-flex items-center justify-center gap-3 px-6 py-4 border border-ink-30 text-ink-70 hover:text-ink hover:border-ink font-mono text-[11px] uppercase tracking-[0.18em] transition-colors duration-200"
          >
            <span>View GitHub</span>
          </a>
          <a
            href="#extensions"
            data-testid="closing-extensions-cta"
            className="relative inline-flex items-center justify-center gap-3 px-6 py-4 border border-ink-30 text-ink-70 hover:text-ink hover:border-ink font-mono text-[11px] uppercase tracking-[0.18em] transition-colors"
          >
            <span>Explore extensions</span>
          </a>
        </motion.div>
      </div>
    </section>
  );
}
